import '@interhyp/shared-consent-manager/esm/index.css';
import { useIdentity } from '@interhyp/platform-auth';
import {
  ConsentManager as SharedConsentManager,
  CONSENT_MANAGER_INITIAL_SLICE_STATE,
} from '@interhyp/shared-consent-manager';
import React from 'react';
import { useSelector } from 'react-redux';

import { getMandantData } from '../../redux/MandantConfig/selectors';

const DEFAULT_STATE = {
  consentManager: {
    ...CONSENT_MANAGER_INITIAL_SLICE_STATE,
    modalOpen: false,
  },
};

function ConsentManager(): React.ReactElement | null {
  const dataProtectionUrl = useSelector(getMandantData)?.urls?.dataProtectionUrl ?? '';
  const imprintUrl = useSelector(getMandantData)?.urls?.imprintUrl ?? '';
  const identity = useIdentity();

  if (identity?.userType === 'PROFESSIONAL') {
    return null;
  }

  return (
    <SharedConsentManager
      privacyLink={dataProtectionUrl ?? ''}
      imprintLink={imprintUrl}
      preloadedState={DEFAULT_STATE}
      privacyCookieLink={dataProtectionUrl ?? ''}
    />
  );
}

export default ConsentManager;
